import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import AdvancedHotkey from './component';

export const messages = defineMessages({
  name: {
    description: 'printingHotkeys Print Pick List',
    defaultMessage: 'Print Pick List',
    id: 'lCIzlR',
  },
});

export const hotkey = ['p', 'l'];
export const barcodeContent = '+NFDC65X8E4MD=';

const PrintPickListHotkey = ({ children = null, handler }) => {
  const intl = useIntl();
  const hotkeyMetadata = useMemo(
    () => ({
      displayHotkeyStrings: ['pl'],
      barcode: barcodeContent,
      hotkey,
      handler,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'printing',
      doNotTrack: true,
    }),
    [intl, handler],
  );

  return <AdvancedHotkey hotkey={hotkeyMetadata}>{children}</AdvancedHotkey>;
};

PrintPickListHotkey.propTypes = {
  children: PropTypes.node,
  handler: PropTypes.func.isRequired,
};

export default PrintPickListHotkey;
